import BadgeDataType from "@/components/ui/badge-data-type";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { DATA_TYPE_VALUES } from "@/constants/dataset";
import {
  ATTRIBUTE_ID,
  DataSchemaType,
  DatasetAttributeSchema,
  DatasetDataType
} from "@/types/dataset";

import { twMerge } from "tailwind-merge";

interface ColorBasedSelectProps {
  title?: string;
  titleClassName?: string;
  selectContentClassName?: string;
  selectTriggerClassName?: string;
  value?: string;
  onValueChange?: (value: string) => void;
  categories: DatasetAttributeSchema[];
  disabled?: boolean;
}

const ColorBasedSelect = ({
  value,
  title = "Color Based On",
  titleClassName,
  selectContentClassName,
  selectTriggerClassName,
  onValueChange,
  categories,
  disabled = false
}: ColorBasedSelectProps) => {
  const filteredCategories = categories.filter(
    (category) =>
      !(category.attribute_name in ATTRIBUTE_ID) &&
      category.data_type !== DATA_TYPE_VALUES[DatasetDataType.TYPE_GEOMETRY] &&
      category.data_type !== DataSchemaType.GEOMETRY
  );

  return (
    <div className="w-full space-y-2">
      <p className={twMerge("text-grey text-xs mb-1", titleClassName)}>
        {title}
      </p>
      <Select value={value} onValueChange={onValueChange} disabled={disabled}>
        <SelectTrigger
          className={twMerge(
            "rounded-xl h-auto w-full [&>span]:w-full",
            selectTriggerClassName
          )}
          data-testid="color-based-select-trigger"
        >
          <SelectValue placeholder="Select a color scale" className="w-full" />
        </SelectTrigger>
        <SelectContent className={selectContentClassName}>
          <SelectGroup className="w-full">
            {filteredCategories.map((category) => (
              <SelectItem
                key={`${category.id}-${category.attribute_name}`}
                value={category.attribute_name}
                data-testid={`color-based-select-option-${category.attribute_name}`}
                className="flex items-center gap-2 py-1 px-3 w-full [&>span]:w-full"
              >
                <div className="flex flex-row items-center gap-2 justify-start w-full rounded-sm overflow-hidden text-txtHeading text-xs">
                  <BadgeDataType type={category.data_type} />
                  <p className="w-3/4 text-left">{category.attribute_name}</p>
                </div>
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};

export default ColorBasedSelect;
